/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 主办方ID
   */
  host_id: string;
}
/**
 * 场地资源
 */
export type VenueResource = {
  /**
   * 1直播大厅，2讨论室
   */
  venue_type?: string;
  /**
   * 数量
   */
  size?: string;
  /**
   * 观众数，方数
   */
  audience_num?: string;
  /**
   * 有效期开始（毫秒），-1表示跟随版本有效期
   */
  start_time?: string;
  /**
   * 有效期结束（毫秒），-1表示跟随版本有效期
   */
  end_time?: string;
  /**
   * 来源
   */
  source?: string;
}[];
/**
 * 嘉宾资源
 */
export type GuestResource = {
  /**
   * 数量，
   */
  value?: string;
  start_time?: string;
  end_time?: string;
  source?: string;
}[];
/**
 * 主持人资源
 */
export type EventHostResource = {
  /**
   * 数量，
   */
  value?: string;
  start_time?: string;
  end_time?: string;
  source?: string;
}[];
export interface DashboardVipGetVipResourceDetailRes {
  data: Data;
  /**
   * 结算提现，0 不开启，1开启
   */
  nonce?: string;
  msg?: string;
  code?: number;
}
export interface Data {
  vip_resource: VipResource;
}
export interface VipResource {
  /**
   * 唯一ID
   */
  id: string;
  /**
   * 主办方ID
   */
  host_id: string;
  /**
   * 规则类型，如：免费(free)，基础(basic)，豪华（deluxe），旗舰版（ultimate）等
   */
  rule_type: string;
  /**
   * 规则ID
   */
  rule_id: string;
  /** 有这个id说明是已付费的 */
  resource_id?: string;
  /**
   * 版本名
   */
  rule_name: string;
  /**
   * 开始时间
   */
  start_time: number;
  /**
   * 结束时间
   */
  end_time: number;
  rule: Rule;
}
export interface Rule {
  /**
   * 日程数量
   */
  scheduler_num?: string;
  /**
   * 活动时长（天）
   */
  event_duration?: string;
  /**
   * 日程批量导入 0 不开启，1开启
   */
  scheduler_batch_import_switch?: string;
  /**
   * 门票类型位枚举（1套票/ 2场次票）
   */
  ticket_group_type_bit?: string;
  /**
   * 直播大厅时长（秒），极大值 999999999999
   */
  stage_time_limit_second?: string;
  /**
   * 讨论室时长（秒），极大值 999999999999
   */
  session_time_limit_second?: string;
  venue_resource?: VenueResource;
  /**
   * 观众导入，0 不开启，1开启
   */
  import_audience_switch?: string;
  guest_resource?: GuestResource;
  event_host_resource?: EventHostResource;
  host_org_member_num?: string;
  /**
   * 报名页模版能力， 1 基础版，2 canvas 4 高级canvas
   */
  registration_page_template_bit?: string;
  /**
   *  渠道统计，0 不开启，1开启
   */
  channel_statistics?: string;
  /**
   * 活动助手是否开启推送，0 不开启，1开启
   */
  activity_shopping_switch?: string;
  /**
   * 是否开启优惠券，0 不开启，1开启
   */
  coupon_switch?: string;
  /**
   * 是否开启折扣，0 不开启，1开启
   */
  discount_switch?: string;
  /**
   * 活动报名问卷类型。1模版问题，2自定义问题
   */
  event_question_type_bit?: string;
  /**
   * 是否开启数据分析/行业对比，0 不开启，1开启
   */
  industry_analyse_switch?: string;
  /**
   * 基础内容编辑器开关，0 不开启，1开启
   */
  canvas_basic_content_editor_switch?: string;
  /**
   * 多端适配开关，0 不开启，1开启
   */
  canvas_multi_client_adaptation_switch?: string;
  /**
   * 自定义布局开关，0 不开启，1开启
   */
  canvas_custom_layout_switch?: string;
  /**
   * 高级模板开关，0 不开启，1开启
   */
  canvas_advanced_template_switch?: string;
  /**
   * 模版调色开关，0 不开启，1开启
   */
  canvas_color_template_switch?: string;
  /**
   * 导出长图开关，0 不开启，1开启
   */
  canvas_export_long_image_switch?: string;
  /**
   * 自动保存开关，0 不开启，1开启
   */
  canvas_auto_save_switch?: string;
  /**
   * 素材库存储空间（单位MB）
   */
  canvas_material_storage_space_mb?: string;
  /**
   * 品牌logo开关，0 不开启，1开启
   */
  canvas_brand_logo_switch?: string;
  /**
   * 第三方链接建联开关，0 不开启，1开启
   */
  canvas_third_party_link_switch?: string;
  /**
   * 付费门票开关，0 不开启，1开启
   */
  paid_ticket_switch?: string;
  /**
   * 资质认证，0 不开启，1开启
   */
  qualification_identity_switch?: string;
  /**
   * 订单查询，0 不开启，1开启
   */
  query_order_switch?: string;
  /**
   * 订单查询，0 不开启，1开启
   */
  refund_switch?: string;
  /**
   * 订单退款，0 不开启，1开启
   */
  withdrawal_switch?: string;
  /**
   * 直播大厅外场观众数（外场方数）
   */
  live_audience_num?: string;
  /**
   * 是否开启回放，0 不开启，1开启
   */
  replay_switch?: string;
  /**
   * 批量导入嘉宾 0 不开启，1开启
   */
  batch_import_guest_switch?: string;
  /**
   * 批量导入观众 0 不开启，1开启
   */
  batch_import_audience_switch?: string;
  /**
   * 活动分享海报类型 0-默认海报，1-高级海报
   */
  shared_poster_type?: string,
}

const DashboardVipGetVipResourceDetail = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardVipGetVipResourceDetailRes>(
    '/wemeet-tapi',
    '/v2/activities/vip/get-vip-resource-detail',
    data,
    ctx,
  );

  return res;
};

export default DashboardVipGetVipResourceDetail;
